import firebase from "firebase/app";
import "firebase/functions";

export async function generateTheme() {
  const f = firebase
    .functions()
    .httpsCallable("theme-generate");
  return await f();
}
